/**
 * Event names used to close the flyout when fired
 */
export var EventType;
(function (EventType) {
    EventType["RESIZE"] = "resize";
    EventType["SCROLL"] = "scroll";
})(EventType || (EventType = {}));
//# sourceMappingURL=FlyoutButton.types.js.map